const EnumBrowser = {
    None: 0,
    GoogleChrome: 1,
    Firefox: 2,
    Safari: 3,
    IE: 4,
    Edge: 5,
    Opera: 6,
    Chromium: 7,
    Other: 8
}

export default EnumBrowser

